/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Discovery_SnapshotInputs */

const en_directory_launch_discovery_snapshot = /** @type {(inputs: Directory_Launch_Discovery_SnapshotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discovery Snapshot`)
};

const zh_directory_launch_discovery_snapshot = /** @type {(inputs: Directory_Launch_Discovery_SnapshotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发现概览`)
};

/**
* | output |
* | --- |
* | "Discovery Snapshot" |
*
* @param {Directory_Launch_Discovery_SnapshotInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_discovery_snapshot = /** @type {((inputs?: Directory_Launch_Discovery_SnapshotInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Discovery_SnapshotInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_discovery_snapshot(inputs)
	return zh_directory_launch_discovery_snapshot(inputs)
});
export { directory_launch_discovery_snapshot as "directory.launch.discovery_snapshot" }